// extracted by mini-css-extract-plugin
export var table = "_v4-0";